module.exports = __webpack_public_path__ + "static/media/login_bg.11c81661.svg";